import type { ClientContext } from '~/services/contextClient';
import type { ThreadCategoriesClientInterface } from './threadCategoriesClient.types';
import CorporateThreadCategoriesClient from './corporateThreadCategoriesClient';

export default class ThreadCategoriesClientFactory {
    static createClient(context: ClientContext): ThreadCategoriesClientInterface {
        if (!context.orgUnitId && !context.groupId) {
            return new CorporateThreadCategoriesClient(context.teamId);
        }

        throw new Error('Thread categories are only available at corporate level');
    }
}
